var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.001 2.00006C8.13098 2.00006 5.00098 5.13006 5.00098 9.00006C5.00098 14.2501 12.001 22.0001 12.001 22.0001C12.001 22.0001 19.001 14.2501 19.001 9.00006C19.001 5.13006 15.871 2.00006 12.001 2.00006ZM7.00098 9.00006C7.00098 6.24006 9.24098 4.00006 12.001 4.00006C14.761 4.00006 17.001 6.24006 17.001 9.00006C17.001 11.8801 14.121 16.1901 12.001 18.8801C9.92098 16.2101 7.00098 11.8501 7.00098 9.00006Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.001 11.5001C13.3817 11.5001 14.501 10.3808 14.501 9.00006C14.501 7.61935 13.3817 6.50006 12.001 6.50006C10.6203 6.50006 9.50098 7.61935 9.50098 9.00006C9.50098 10.3808 10.6203 11.5001 12.001 11.5001Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.41964d757b8ede700de7d1807e13fdf1.svg";
export { ForwardRef as ReactComponent };